import {
  CognitoUserPool,
  CognitoUser,
  AuthenticationDetails
} from 'amazon-cognito-identity-js'
import poolData from '../pool-data'

export default {
  signIn: (user, authAction) => {
    return new Promise((resolve, reject) => {
      const userPool = new CognitoUserPool(poolData)

      const authenticationData = {
        Username: user.username,
        Password: user.password
      }
      const authenticationDetails = new AuthenticationDetails(
        authenticationData
      )

      const userData = {
        Username: user.username,
        Pool: userPool
      }
      const cognitoUser = new CognitoUser(userData)

      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: result => {
          resolve({
            username: cognitoUser.getUsername()
          })
        },
        onFailure: err => {
          reject(err)
        },
        newPasswordRequired: (userAttributes, requiredAttributes) => {
          /* User was signed up by an admin and must provide new
          password and required attributes, if any, to complete
          authentication. */

          if (authAction === 'password_challenge') {
            cognitoUser.completeNewPasswordChallenge(user.newPassword, [], {
              onSuccess: result => {
                resolve({
                  status: 'new_password_challenge_completed',
                  username: cognitoUser.getUsername()
                })
              },
              onFailure: err => {
                reject(err)
              }
            })
          } else {
            resolve({
              state: 'new_password_required',
              result: {
                userAttributes: userAttributes,
                requiredAttributes: requiredAttributes
              }
            })
          }
        }
      })
    })
  },
  signOut: () => {
    return new Promise((resolve, reject) => {
      try {
        const userPool = new CognitoUserPool(poolData)
        const cognitoUser = userPool.getCurrentUser()

        if (cognitoUser) {
          cognitoUser.signOut()
          resolve(cognitoUser)
        }
      } catch (err) {
        reject(err)
      }
    })
  },
  forgotPassword: (username, authAction) => {
    return new Promise((resolve, reject) => {
      const userPool = new CognitoUserPool(poolData)

      const userData = {
        Username: username,
        Pool: userPool
      }
      const cognitoUser = new CognitoUser(userData)

      cognitoUser.forgotPassword({
        onSuccess: result => {
          resolve(result)
        },
        onFailure: err => {
          reject(err)
        },
        inputVerificationCode () {
          resolve()
        }
      })
    })
  },
  forgotPasswordSubmit: (username, verificationCode, newPassword) => {
    return new Promise((resolve, reject) => {
      const userPool = new CognitoUserPool(poolData)

      const userData = {
        Username: username,
        Pool: userPool
      }
      const cognitoUser = new CognitoUser(userData)

      cognitoUser.confirmPassword(verificationCode, newPassword, {
        onSuccess: result => {
          resolve(result)
        },
        onFailure: err => {
          reject(err)
        }
      })
    })
  },
  changePassword: (currentPassword, newPassword) => {
    return new Promise((resolve, reject) => {
      try {
        const userPool = new CognitoUserPool(poolData)
        const cognitoUser = userPool.getCurrentUser()

        if (cognitoUser != null) {
          cognitoUser.getSession((err, session) => {
            if (err) {
              reject(err)
            }

            cognitoUser.changePassword(
              currentPassword,
              newPassword,
              (err, result) => {
                if (err) {
                  reject(err)
                }
                resolve(result)
              }
            )
          })
        }
      } catch (err) {
        reject(err)
      }
    })
  },
  getJwtToken: () => {
    return new Promise((resolve, reject) => {
      try {
        const userPool = new CognitoUserPool(poolData)
        const cognitoUser = userPool.getCurrentUser()

        if (!cognitoUser) {
          throw new Error(
            `Error in getJwtToken: cognitoUser is ${cognitoUser}`
          )
        }

        cognitoUser.getSession((err, session) => {
          if (err) {
            reject(err)
          }

          if (!session) {
            throw new Error(
              'There was an error trying to retrieve the access token'
            )
          }

          if (!session.accessToken) {
            throw new Error(
              'There was an error trying to retrieve the access token'
            )
          }

          resolve(session.accessToken.jwtToken)
        })
      } catch (err) {
        reject(err)
      }
    })
  }
}
